import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionRequest } from './get-collection-request';
import type { IGetCollectionResponse } from './get-collection-response';
import { getCollectionResponseSchema } from './get-collection-response';

export async function getCollectionApi({
  id,
}: IGetCollectionRequest): Promise<IValidatedResponse<IGetCollectionResponse>> {
  return getRequest<IGetCollectionResponse>({
    path: `/sys/collections/${id}`,
    schema: getCollectionResponseSchema,
  });
}
